import { Chip, Typography, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import MoreIcon from "@material-ui/icons/MoreVert";
import Alert from "@material-ui/lab/Alert";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment-timezone";
import React, { Component } from "react";
import { defaultColor } from "../constants/DefaultColor";
import { languages } from "../constants/languages";
import vrsn from "../constants/vrsn";
import DeleteDialog from "./DeleteDialog";

const amateurLogo = require("../img/trophy-amateur.png");
const worldclassLogo = require("../img/trophy-worldclass.png");
const legendaryLogo = require("../img/trophy-legendary.png");
const proLogo = require("../img/trophy-pro.png");

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3),
    margin: theme.spacing(1, 0),
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      // transform: "translateY(-2px)",
      background: "#F5F5F5",
    },
    "&:active": {
      transform: "translateY(0px)",
      transition: "transform 0.1s",
    },
  },
  trophyContainer: {
    width: 56,
    height: 56,
    marginRight: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    "$root:hover &": {
      transform: "scale(1.05)",
    },
  },
  contentContainer: {
    flex: 1,
    minWidth: 0,
    marginRight: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  title: {
    fontWeight: 400,
    fontSize: "1.1rem",
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
  },
  metaContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  moreButton: {
    opacity: 0.7,
    transition: "all 0.3s ease",
    backgroundColor: theme.palette.grey[50],
    borderRadius: 12,
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
      transform: "scale(1.1)",
    },
    "$root:hover &": {
      opacity: 1,
    },
  },
});

class TournamentListElement extends Component {
  state = {
    anchorEl: null,
    deleteDialogOpen: false,
    confirmationShown: false,
    copyDialogOpen: false,
    copying: false,
    withTeams: true,
    removeAdminDialogOpen: false,
    copyName: "",
    copyDays: [],
    copyDaysLoading: false,
  };

  getTournamentTimezone = () => {
    return this.props.tournament.timezone || "Europe/Amsterdam";
  };

  toggleDeleteDialog = (e) => {
    e.stopPropagation();
    this.setState({
      deleteDialogOpen: !this.state.deleteDialogOpen,
      confirmationShown: false,
    });
  };

  toggleCopyDialog = (e, withTeams) => {
    e.stopPropagation();
    const opening = !this.state.copyDialogOpen;
    if (!opening) {
      this.setState({
        copyDialogOpen: false,
        copying: false,
        copyDays: [],
        copyDaysLoading: false,
      });
      return;
    }

    const timezone = this.getTournamentTimezone();
    const defaultName =
      this.props.tournament.name + " (" + languages.general.copy2 + ")";
    this.setState({
      copyDialogOpen: true,
      withTeams: withTeams,
      copyName: defaultName,
      copyDays: [],
      copyDaysLoading: true,
      copying: false,
      anchorEl: null,
    });

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .get()
      .then((result) => {
        if (!this.state.copyDialogOpen) {
          return;
        }
        const firstDay = {
          id: "0",
          originalDate: this.props.tournament.date,
          newDate: moment.unix(this.props.tournament.date).tz(timezone),
        };
        const extraDays = [];
        result.forEach((r) => {
          const data = r.data();
          extraDays.push({
            id: r.id,
            originalDate: data.date,
            newDate: moment.unix(data.date).tz(timezone),
          });
        });
        extraDays.sort((a, b) => a.originalDate - b.originalDate);
        this.setState({
          copyDays: [firstDay, ...extraDays],
          copyDaysLoading: false,
        });
      })
      .catch(() => {
        if (this.state.copyDialogOpen) {
          this.setState({
            copyDays: [
              {
                id: "0",
                originalDate: this.props.tournament.date,
                newDate: moment
                  .unix(this.props.tournament.date)
                  .tz(timezone),
              },
            ],
            copyDaysLoading: false,
          });
        }
      });
  };

  handleCopyNameChange = (e) => {
    this.setState({ copyName: e.target.value });
  };

  handleCopyDayDateChange = (dayId, date) => {
    const timezone = this.getTournamentTimezone();
    this.setState({
      copyDays: this.state.copyDays.map((day) =>
        day.id === dayId
          ? {
              ...day,
              newDate: date ? date.tz(timezone) : day.newDate,
            }
          : day
      ),
    });
  };

  toggleRemoveAdminDialog = (e) => {
    e.stopPropagation();
    this.setState({ removeAdminDialogOpen: !this.state.removeAdminDialogOpen });
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState({ anchorEl: null });
  };

  handleDeleteTournament = (e) => {
    e.stopPropagation();
    if (!this.state.confirmationShown) {
      this.setState({ confirmationShown: true });
    } else {
      const db = window.firebase.firestore();
      let batch = db.batch();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);

      if (this.props.tournament.liveLink) {
        const liveLinkRef = db
          .collection("liveLinks")
          .doc(this.props.tournament.liveLink);
        batch.delete(liveLinkRef);
      }

      batch.delete(tournamentRef);
      batch.commit();
    }
  };

  handleCopyTournament = (e) => {
    e.stopPropagation();
    const copyName = (this.state.copyName || "").trim();
    if (!copyName || this.state.copyDaysLoading) {
      return;
    }
    this.setState({ copying: true });
    const timezone = this.getTournamentTimezone();
    const dayDateMap = {};
    this.state.copyDays.forEach((day) => {
      dayDateMap[day.id] = day.newDate.tz(timezone).unix();
    });
    let newTournament = { ...this.props.tournament };
    if (
      this.props.tournament.status === 1 ||
      this.props.tournament.status === 2 ||
      this.props.tournament.status === 3
    ) {
      newTournament["requireUpgrade"] = true;
    }
    newTournament["name"] = copyName;
    newTournament["copy"] = this.props.tournament[".key"];
    delete newTournament["liveLink"];
    delete newTournament["status"];
    delete newTournament["ia"];
    // newTournament["admins"] = [];
    newTournament["vrsn"] = vrsn;
    if (dayDateMap["0"] !== undefined) {
      const oldDate = this.props.tournament.date;
      const newDate = dayDateMap["0"];
      newTournament["date"] = newDate;
      if (newTournament.endDate) {
        newTournament["endDate"] =
          newTournament.endDate + (newDate - oldDate);
      }
    }
    const db = window.firebase.firestore();
    const oldTournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const tournamentRef = db.collection("tournaments").doc();
    newTournament[".key"] = tournamentRef.id;
    tournamentRef.set(newTournament).then(() => {
      let setArray = [];
      oldTournamentRef
        .collection("brackets")
        .get()
        .then((result) => {
          result.forEach((r) => {
            setArray.push([
              tournamentRef.collection("brackets").doc(r.id),
              r.data(),
            ]);
          });
          oldTournamentRef
            .collection("days")
            .get()
            .then((result) => {
              result.forEach((r) => {
                let dayData = r.data();
                if (dayDateMap[r.id] !== undefined) {
                  dayData = { ...dayData, date: dayDateMap[r.id] };
                }
                setArray.push([
                  tournamentRef.collection("days").doc(r.id),
                  dayData,
                ]);
              });
              oldTournamentRef
                .collection("dias")
                .get()
                .then((result) => {
                  result.forEach((r) => {
                    setArray.push([
                      tournamentRef.collection("dias").doc(r.id),
                      r.data(),
                    ]);
                  });
                  oldTournamentRef
                    .collection("divisions")
                    .get()
                    .then((result) => {
                      result.forEach((r) => {
                        let division = r.data();
                        if (division.fases) {
                          (division.fases || []).forEach((phase, i) => {
                            if (i !== 0) {
                              division.fases[i]["started"] = false;
                            }
                          });
                        }
                        setArray.push([
                          tournamentRef.collection("divisions").doc(r.id),
                          division,
                        ]);
                      });
                      oldTournamentRef
                        .collection("matches")
                        .get()
                        .then((result) => {
                          result.forEach((r) => {
                            let match = r.data();
                            match["score1"] = null;
                            match["score2"] = null;
                            match["winner"] = null;
                            match["sets"] = {};
                            match["extra1"] = {};
                            match["extra2"] = {};
                            match["penalties1"] = null;
                            match["penalties2"] = null;
                            match["playerPoints"] = {};
                            match["goals"] = [];
                            match["history"] = {};
                            setArray.push([
                              tournamentRef.collection("matches").doc(r.id),
                              match,
                            ]);
                          });
                          oldTournamentRef
                            .collection("poules")
                            .get()
                            .then((result) => {
                              result.forEach((r) => {
                                let poule = r.data();
                                if (!this.state.withTeams && poule.bracket) {
                                  poule["status0"] = null;
                                  poule["status1"] = null;
                                }
                                if (poule.minusPoints) {
                                  poule.minusPoints = {};
                                }
                                if (poule.plusPoints) {
                                  poule.plusPoints = {};
                                }
                                setArray.push([
                                  tournamentRef.collection("poules").doc(r.id),
                                  poule,
                                ]);
                              });
                              oldTournamentRef
                                .collection("referees")
                                .get()
                                .then((result) => {
                                  result.forEach((r) => {
                                    setArray.push([
                                      tournamentRef
                                        .collection("referees")
                                        .doc(r.id),
                                      r.data(),
                                    ]);
                                  });
                                  oldTournamentRef
                                    .collection("resultSpots")
                                    .get()
                                    .then((result) => {
                                      result.forEach((r) => {
                                        setArray.push([
                                          tournamentRef
                                            .collection("resultSpots")
                                            .doc(r.id),
                                          r.data(),
                                        ]);
                                      });
                                      oldTournamentRef
                                        .collection("slideshows")
                                        .get()
                                        .then((result) => {
                                          result.forEach((r) => {
                                            setArray.push([
                                              tournamentRef
                                                .collection("slideshows")
                                                .doc(r.id),
                                              r.data(),
                                            ]);
                                          });
                                          oldTournamentRef
                                            .collection("sportParks")
                                            .get()
                                            .then((result) => {
                                              result.forEach((r) => {
                                                setArray.push([
                                                  tournamentRef
                                                    .collection("sportParks")
                                                    .doc(r.id),
                                                  r.data(),
                                                ]);
                                              });
                                              oldTournamentRef
                                                .collection("attachments")
                                                .get()
                                                .then((result) => {
                                                  result.forEach((r) => {
                                                    setArray.push([
                                                      tournamentRef
                                                        .collection(
                                                          "attachments"
                                                        )
                                                        .doc(r.id),
                                                      r.data(),
                                                    ]);
                                                  });
                                                  oldTournamentRef
                                                    .collection("admins")
                                                    .get()
                                                    .then((result) => {
                                                      result.forEach((r) => {
                                                        setArray.push([
                                                          tournamentRef
                                                            .collection(
                                                              "admins"
                                                            )
                                                            .doc(r.id),
                                                          r.data(),
                                                        ]);
                                                      });
                                                      oldTournamentRef
                                                        .collection("pictures")
                                                        .get()
                                                        .then((result) => {
                                                          result.forEach(
                                                            (r) => {
                                                              setArray.push([
                                                                tournamentRef
                                                                  .collection(
                                                                    "pictures"
                                                                  )
                                                                  .doc(r.id),
                                                                r.data(),
                                                              ]);
                                                            }
                                                          );

                                                          oldTournamentRef
                                                            .collection("teams")
                                                            .get()
                                                            .then((result) => {
                                                              if (
                                                                this.state
                                                                  .withTeams
                                                              ) {
                                                                result.forEach(
                                                                  (r) => {
                                                                    let team =
                                                                      r.data();
                                                                    team[
                                                                      "present"
                                                                    ] = false;
                                                                    Object.keys(
                                                                      team
                                                                    ).forEach(
                                                                      (key) => {
                                                                        if (
                                                                          key.startsWith(
                                                                            "poule"
                                                                          ) &&
                                                                          key !==
                                                                            "poule0"
                                                                        ) {
                                                                          team[
                                                                            key
                                                                          ] =
                                                                            null;
                                                                        }
                                                                      }
                                                                    );
                                                                    setArray.push(
                                                                      [
                                                                        tournamentRef
                                                                          .collection(
                                                                            "teams"
                                                                          )
                                                                          .doc(
                                                                            r.id
                                                                          ),
                                                                        team,
                                                                      ]
                                                                    );
                                                                  }
                                                                );
                                                              }
                                                              oldTournamentRef
                                                                .collection(
                                                                  "players"
                                                                )
                                                                .get()
                                                                .then(
                                                                  (result) => {
                                                                    if (
                                                                      this.state
                                                                        .withTeams
                                                                    ) {
                                                                      result.forEach(
                                                                        (r) => {
                                                                          let player =
                                                                            r.data();
                                                                          player[
                                                                            "matches"
                                                                          ] =
                                                                            [];
                                                                          setArray.push(
                                                                            [
                                                                              tournamentRef
                                                                                .collection(
                                                                                  "players"
                                                                                )
                                                                                .doc(
                                                                                  r.id
                                                                                ),
                                                                              player,
                                                                            ]
                                                                          );
                                                                        }
                                                                      );
                                                                    }
                                                                    oldTournamentRef
                                                                      .collection(
                                                                        "playersContactInfo"
                                                                      )
                                                                      .get()
                                                                      .then(
                                                                        (
                                                                          result
                                                                        ) => {
                                                                          if (
                                                                            this
                                                                              .state
                                                                              .withTeams
                                                                          ) {
                                                                            result.forEach(
                                                                              (
                                                                                r
                                                                              ) => {
                                                                                setArray.push(
                                                                                  [
                                                                                    tournamentRef
                                                                                      .collection(
                                                                                        "playersContactInfo"
                                                                                      )
                                                                                      .doc(
                                                                                        r.id
                                                                                      ),
                                                                                    r.data(),
                                                                                  ]
                                                                                );
                                                                              }
                                                                            );
                                                                          }
                                                                          oldTournamentRef
                                                                            .collection(
                                                                              "teamsContactInfo"
                                                                            )
                                                                            .get()
                                                                            .then(
                                                                              (
                                                                                result
                                                                              ) => {
                                                                                if (
                                                                                  this
                                                                                    .state
                                                                                    .withTeams
                                                                                ) {
                                                                                  result.forEach(
                                                                                    (
                                                                                      r
                                                                                    ) => {
                                                                                      setArray.push(
                                                                                        [
                                                                                          tournamentRef
                                                                                            .collection(
                                                                                              "teamsContactInfo"
                                                                                            )
                                                                                            .doc(
                                                                                              r.id
                                                                                            ),
                                                                                          r.data(),
                                                                                        ]
                                                                                      );
                                                                                    }
                                                                                  );
                                                                                }
                                                                                var i,
                                                                                  j;
                                                                                for (
                                                                                  i = 0,
                                                                                    j =
                                                                                      setArray.length;
                                                                                  i <
                                                                                  j;
                                                                                  i += 200
                                                                                ) {
                                                                                  let temparray =
                                                                                    setArray.slice(
                                                                                      i,
                                                                                      i +
                                                                                        200
                                                                                    );
                                                                                  let batch =
                                                                                    db.batch();

                                                                                  for (
                                                                                    let t = 0;
                                                                                    t <
                                                                                    temparray.length;
                                                                                    t++
                                                                                  ) {
                                                                                    let toSet =
                                                                                      temparray[
                                                                                        t
                                                                                      ];
                                                                                    batch.set(
                                                                                      toSet[0],
                                                                                      toSet[1]
                                                                                    );
                                                                                  }
                                                                                  batch.commit();
                                                                                  if (
                                                                                    i +
                                                                                      200 >=
                                                                                    setArray.length
                                                                                  ) {
                                                                                    this.toggleCopyDialog(
                                                                                      e
                                                                                    );
                                                                                  }
                                                                                }
                                                                              }
                                                                            );
                                                                        }
                                                                      );
                                                                  }
                                                                );
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
  };

  handleRemoveAdminSelf = (e) => {
    e.stopPropagation();
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    const admins = this.props.tournament.admins;
    let batch = db.batch();
    admins.splice(admins.indexOf(this.props.user.uid), 1);
    batch.update(tournamentRef, { admins: admins });
    batch.commit();

    tournamentRef.collection("admins").doc(this.props.user.uid).delete();
  };

  render() {
    const { tournament, classes } = this.props;
    const isUpgraded = tournament.status === 1 || tournament.status === 2;

    // Prefer the account-level subscription status when the user actually
    // has a paid tier (Worldclass/Legendary/Pro applies to every tournament
    // the user owns); fall back to the tournament's own one-off status when
    // the user has no subscription (status 0 = Amateur, or unset).
    const accountStatus = (this.props.userStatus || {}).status;
    const effectiveStatus = accountStatus > 0 ? accountStatus : tournament.status;

    const getStatusColor = (status) => {
      switch (status) {
        case 2: // Legendary
          return { bg: "#FFE3E3", text: "#E03131" };
        case 1: // Worldclass
          return { bg: "#FFF3BF", text: "#E67700" };
        case 3: // Pro
          return { bg: "#E9FAC8", text: "#5C940D" };
        default:
          return { bg: "#F5F5F5", text: "#757575" };
      }
    };

    const statusColors = getStatusColor(effectiveStatus);

    return (
      <>
        <Paper
          className={classes.root}
          onClick={(e) =>
            this.props.handleTournamentClick(e, tournament[".key"])
          }
        >
          <div
            className={classes.trophyContainer}
            style={{
              background: `linear-gradient(to bottom right, ${
                tournament.color || defaultColor
              }, ${tournament.color || defaultColor}80)`,
            }}
          >
            <img
              src={
                tournament.logoURL
                  ? tournament.logoURL
                  : effectiveStatus === 2
                  ? legendaryLogo
                  : effectiveStatus === 1
                  ? worldclassLogo
                  : effectiveStatus === 3
                  ? proLogo
                  : amateurLogo
              }
              alt=""
              style={{ width: 32 }}
            />
          </div>

          <div className={classes.contentContainer}>
            <Typography variant="body1" className={classes.title}>
              {tournament.name}
            </Typography>

            <div className={classes.metaContainer}>
              <Chip
                size="small"
                style={{
                  backgroundColor: "#EDEFF1",
                  // color: "#f5f5f5",
                  height: 28,
                  fontWeight: 500,
                  borderRadius: 5,
                  fontSize: "0.875rem",
                }}
                label={moment
                  .unix(tournament.date)
                  .tz(tournament.timezone || "Europe/Amsterdam")
                  .format(languages.createTournament.dateFormat)}
              />

              {tournament.nvdCode ? (
                <Chip
                  size="small"
                  style={{
                    backgroundColor: "#f16522",
                    color: "white",
                    height: 28,
                    fontWeight: 600,
                    borderRadius: 5,
                    fontSize: "0.75rem",
                  }}
                  label="De Nationale Voetbaldag"
                />
              ) : (
                effectiveStatus > 0 && (
                  <Chip
                    size="small"
                    style={{
                      backgroundColor: statusColors.bg,
                      color: statusColors.text,
                      height: 28,
                      fontWeight: 500,
                      borderRadius: 5,
                      fontSize: "0.875rem",
                    }}
                    label={
                      languages.tournamentStatus[effectiveStatus] &&
                      languages.tournamentStatus[effectiveStatus].name
                    }
                  />
                )
              )}

              {this.props.shared && (
                <Chip
                  size="small"
                  style={{
                    backgroundColor: "#E3F2FD",
                    color: "#1976D2",
                    height: 28,
                    fontWeight: 500,
                    borderRadius: 5,
                    fontSize: "0.875rem",
                  }}
                  label={languages.tournament.shared}
                />
              )}
            </div>
          </div>

          {!(this.props.userData || {}).isPSD && (
            <IconButton
              className={classes.moreButton}
              onClick={(e) => {
                e.stopPropagation();
                this.handleMenu(e);
              }}
              size="small"
            >
              <MoreIcon />
            </IconButton>
          )}
        </Paper>

        <DeleteDialog
          open={this.state.removeAdminDialogOpen}
          toggleDialog={this.toggleRemoveAdminDialog}
          handleDelete={this.handleRemoveAdminSelf}
          title={languages.tournament.removeMyselfAsAdmin}
          description={languages.tournament.removeMyselfAsAdminConfirmation}
          confirmationShown={true}
          confirmationButtonText={languages.tournament.remove}
        />

        <DeleteDialog
          open={this.state.deleteDialogOpen}
          toggleDialog={this.toggleDeleteDialog}
          handleDelete={this.handleDeleteTournament}
          title={languages.tournament.deleteTournament}
          description={languages.tournament.deleteTournamentWarning}
          confirmationShown={this.state.confirmationShown}
          errorMessage={
            this.state.confirmationShown
              ? isUpgraded
                ? languages.tournament.upgradedWarning
                : languages.tournament.areYouSure
              : ""
          }
          confirmationButtonText={languages.general.delete}
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.copyDialogOpen}
          onClose={this.toggleCopyDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {languages.tournament.copyTournament}
          </DialogTitle>
          <DialogContent style={{ width: 400, maxWidth: "97%" }}>
            <DialogContentText>
              {languages.tournament.copyTournamentText}
            </DialogContentText>
            {(this.props.tournament.status === 1 ||
              this.props.tournament.status === 2) &&
              (this.props.userStatus || {}).status !== 1 &&
              (this.props.userStatus || {}).status !== 2 && (
                <Alert severity="info" style={{ marginTop: 8, marginBottom: 8 }}>
                  {languages.tournament.requireUpgrade.trim()}
                </Alert>
              )}
            <TextField
              autoFocus
              fullWidth
              margin="normal"
              label={languages.general.nameTournament}
              name="copyName"
              value={this.state.copyName}
              onChange={this.handleCopyNameChange}
              disabled={this.state.copying}
            />
            {this.state.copyDaysLoading ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
                <CircularProgress size={24} />
              </div>
            ) : (
              this.state.copyDays.map((day, index) => (
                <KeyboardDatePicker
                  key={day.id}
                  fullWidth
                  margin="normal"
                  name={"copyDay-" + day.id}
                  label={languages.schedule.day + " " + (index + 1)}
                  format={languages.createTournament.dateFormat}
                  cancelLabel={languages.createTournament.cancel}
                  autoOk={true}
                  value={day.newDate}
                  onChange={(date) =>
                    this.handleCopyDayDateChange(day.id, date)
                  }
                  placeholder={languages.createTournament.datePlaceholder}
                  invalidLabel={languages.createTournament.invalidDateLabel}
                  disabled={this.state.copying}
                />
              ))
            )}
          </DialogContent>
          <DialogActions>
            <div style={{ position: "relative", display: "inline" }}>
              <Button
                onClick={this.toggleCopyDialog}
                color="primary"
                disabled={this.state.copying}
              >
                {languages.general.cancel}
              </Button>
              <Button
                onClick={this.handleCopyTournament}
                variant="contained"
                color="primary"
                disabled={
                  this.state.copying ||
                  this.state.copyDaysLoading ||
                  !(this.state.copyName || "").trim()
                }
              >
                {languages.general.copy}
              </Button>
              {this.state.copying && (
                <CircularProgress
                  size={24}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "75%",
                    marginTop: -12,
                    marginLeft: -12,
                  }}
                />
              )}
            </div>
          </DialogActions>
        </Dialog>

        <Menu
          id="menu-more"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          {!this.props.shared ? (
            <>
              <MenuItem
                onClick={(e) => {
                  this.toggleCopyDialog(e, true);
                }}
              >
                {languages.tournament.copyTournament +
                  " (" +
                  languages.tournament.withTeams +
                  ")"}
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  this.toggleCopyDialog(e, false);
                }}
              >
                {languages.tournament.copyTournament +
                  " (" +
                  languages.tournament.withoutTeams +
                  ")"}
              </MenuItem>
              <MenuItem onClick={this.toggleDeleteDialog}>
                {languages.tournament.deleteTournament}
              </MenuItem>
            </>
          ) : (
            <MenuItem onClick={this.toggleRemoveAdminDialog}>
              {languages.tournament.removeMyselfAsAdmin}
            </MenuItem>
          )}
        </Menu>
      </>
    );
  }
}

export default withStyles(styles)(TournamentListElement);
